<header
  class="relative header flex sm:pl-4 border-b-2 mb-1  items-center sm:pt-0 sm:h-14 sm:flex-row flex-col h-32 !p-8 justify-center gap-[0.3rem] bg-white"
>
  <div
    class="flex w-full sm:w-auto items-center lg:justify-end sm:justify-center min-w-[16.5rem] gap-2"
  >
    <hlm-icon
      data-testid="toggler"
      class="block flex-4 w-7 h-7 mr-4 text-black xl:hidden"
      [name]="menuOpen ? 'lucideX' : 'lucideMenu'"
      (click)="toggleMenu()"
    />

    <div class="w-full flex justify-center">
      <img
      loading="lazy"
      class="flex-grow sm:flex-grow-0"
      class="w-64 h-14"
      src="assets/logo_helipagos_horizontal.svg"
      alt="logo"
      />
    </div>

    <hlm-icon
    class="block flex-4 w-7 h-7 ml-4 text-white 2xl:hidden lg:hidden invisible"
    [name]="menuOpen ? 'lucideX' : 'lucideMenu'"
    (click)="toggleMenu()"
    />
  </div>

  <div  class="flex-3 rounded-2xl py-1 px-2 text-sm font-medium mt-2 text-white bg-[#505B92]" >
    Dash Admin
  </div>


  <div class="flex-1 flex  justify-end items-center gap-2 ">

    <h4 class="text-[1.5rem] font-normal text-[#00228E] ">
    {{ titleCaseWord(username()) }}
  </h4>
  <div  class="flex-3 rounded-2xl py-1 px-2 text-[0.6rem] font-medium mt-2 border border-[#00228E] text-[#00228E] " >
  {{ role() }}
  </div>
  </div>

  <hlm-menu-bar class="border-none">
    <button hlmMenuBarItem class="" [brnMenuTriggerFor]="file">
      <hlm-avatar class="w-8 h-8 sm:block hidden">
        <img src="/assets/pic.png" alt="user of helipagos" hlmAvatarImage />
        <span class="text-white bg-destructive" hlmAvatarFallback>HP</span>
      </hlm-avatar>
    </button>
  </hlm-menu-bar>

  <ng-template #file>
    <hlm-menu variant="menubar" class="w-48">
      <hlm-menu-group>
        <button hlmMenuItem class="text-start">
          Usuario:
          <br />
          {{ username() }}
        </button>
        <button (click)="logOffTheWeb()" hlmMenuItem class="text-hp-orange">
          Cerrar sesión
        </button>
      </hlm-menu-group>
    </hlm-menu>
  </ng-template>
</header>
